<template>
  <div>
    <label for="immat">
      <slot></slot>
    </label>
    <input ref="input" id="immat" type="text" @blur="check" v-model="componentImmat" maxlength="9" minlength="9" v-bind="$attrs"
           pattern="[A-Z]{2}-[0-9]{3}-[A-Z]{2}">
  </div>
</template>

<script>

export default {
  name: "InputImmat",
  components: {},
  inheritAttrs: false,
  props: {
    immat: {
      type: [String, Object],
    },
  },
  data() {
    return {
      componentImmat: '',
    }
  },
  watch: {
    immat(value) {
      this.componentImmat = value
    },
    async componentImmat(newVal, oldVal) {
      // console.log(newVal, oldVal)
      if (undefined !== newVal && undefined !== oldVal && null !== newVal && null !== oldVal) {
        if (oldVal.length === 1 && newVal.length === 2) {
          this.componentImmat = `${this.componentImmat.toUpperCase()}-`;
        }
        if (oldVal.length === 5 && newVal.length === 6) {
          this.componentImmat = `${this.componentImmat.toUpperCase()}-`
        }
        if (/*oldVal.length === 8 && */newVal.length === 9) {
          new Promise((resolve) => {
            resolve(this.componentImmat = this.componentImmat.toUpperCase())
          }).then(() => {
            if (this.$refs.input.checkValidity()) {
              this.$emit('update:immat', this.componentImmat)
            } else {
              this.$refs.input.reportValidity()
            }
          })
        }
      }
      if (null !== newVal && null === oldVal) {
        if (/*oldVal.length === 8 && */newVal.length === 9) {
          new Promise((resolve) => {
            resolve(this.componentImmat = this.componentImmat.toUpperCase())
          }).then(() => {
            if (this.$refs.input.checkValidity()) {
              this.$emit('update:immat', this.componentImmat)
            } else {
              this.$refs.input.reportValidity()
            }
          })
        }
      }
      if ('' === newVal) {
        this.$emit('update:immat', '');
      }
    },
  },
  methods: {
    check() {
      if (!this.$refs.input.checkValidity()) {
        this.$refs.input.reportValidity()
      }
    },
  },
  beforeMount() {
    this.componentImmat = this.immat
  },
}
</script>

<style scoped lang="scss">

</style>
